var _g, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBlogDecor = function SvgBlogDecor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blog-decor_svg__clip0_8123_50691)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.194 21.889c-.074-.897-.232-1.862-.616-2.677-.457-.967-1.23-1.517-2.078-1.973-1.088-.587-2.296-1.027-3.37-1.673-.4-.24-.499-.522-.544-.644a1.184 1.184 0 01-.009-.825c.1-.287.317-.659.877-.792.08-.02.2-.04.356-.034.113.005.453.079.598.09.358.027.713.065 1.069.106 1.185.138 2.18.3 3.367.055 1.612-.333 2.673-.815 3.316-1.68.623-.836.85-1.974.94-3.482.003-.144.01-.287.023-.426a1.217 1.217 0 012.43.16c-.006.138-.013.274-.022.408-.037 2.06 1.074 4.75 2.222 6.449.355.523 1.487 1.453 2.15 2.27.488.603.755 1.206.785 1.66.021.305-.056.536-.156.718-.145.264-.36.457-.652.572-.159.063-.362.106-.601.089a4.182 4.182 0 01-.52-.115c-.453.01-.902.05-1.354.046-1.079-.01-1.854.33-2.86.709-.94.354-1.599.83-2.233 1.614-.059.108-.536.982-.756 1.277-.32.43-.704.574-.9.611-.333.063-.594.01-.801-.076a1.297 1.297 0 01-.69-.652 1.592 1.592 0 01-.146-.79c.014-.256.155-.904.175-.995zm-.185-5.92c.108-.018.217-.038.328-.061 2.362-.488 3.836-1.345 4.778-2.612l.031-.043c.451 1.136 1.01 2.205 1.59 3.062.238.353.788.883 1.347 1.446-1.235.047-2.195.406-3.397.86-.918.345-1.652.769-2.314 1.353a8.418 8.418 0 00-.592-1.802 6.052 6.052 0 00-1.771-2.203z",
    fill: "#000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.369,
    cy: 17.041,
    r: 2,
    transform: "rotate(-75.079 8.37 17.04)",
    fill: "#092047"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.502,
    cy: 46.475,
    r: 2,
    transform: "rotate(-75.079 29.502 46.475)",
    fill: "#A7B0C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blog-decor_svg__clip0_8123_50691"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-75.079 24.08 -1.624)",
    d: "M0 0h19v19H0z"
  })))));
};
export default SvgBlogDecor;